import React, { createContext, useEffect, useState } from "react";

import { ThemeEnum } from "@/enums";
import { ThemeType } from "@/types";

const initialState: {
    theme: ThemeType,
    setTheme: (theme: ThemeType) => void, // eslint-disable-line
} = {
    setTheme: () => null,
    theme: ThemeEnum.SYSTEM,
};

export const ThemeProviderContext = createContext(initialState);

export const ThemeProvider = ({
    children,
    defaultTheme = ThemeEnum.SYSTEM,
    storageKey = "vite-ui-theme",
    ...props
} : {
    children: React.ReactNode,
    defaultTheme?: ThemeType,
    storageKey?: string,
}) => {
    const [theme, setTheme] = useState<ThemeType>(() => (localStorage.getItem(storageKey) as ThemeType) || defaultTheme);

    useEffect(
        () => {
            const root = window.document.documentElement;

            root.classList.remove(
                ThemeEnum.LIGHT,
                ThemeEnum.DARK,
            );

            if (theme === ThemeEnum.SYSTEM) {
                const systemTheme = window.matchMedia(`(prefers-color-scheme: ${ThemeEnum.DARK})`).
                    matches
                    ? ThemeEnum.DARK
                    : ThemeEnum.LIGHT;

                root.classList.add(systemTheme);
                return;
            }

            root.classList.add(theme);
        },
        [theme],
    );

    const value = { // eslint-disable-line
        setTheme: (theme: ThemeType) => { // eslint-disable-line
            localStorage.setItem(
                storageKey,
                theme,
            );

            setTheme(theme);
        },
        theme,
    };

    return (
        <ThemeProviderContext.Provider
            {...props}
            value={value}
        >
            {children}
        </ThemeProviderContext.Provider>
    );
};
